export default __webpack_public_path__ + "static/logo-ganztags-656c9c143775f8c1604eb2a5cbea2dcb.png";